import { z } from 'zod'
import { useZodForm, validateEmissionDate } from '@minetrace/ui/forms'

const currentYear = new Date().getFullYear()

// TrackedInput type="number" emits a string; pipe through Number() before
// running the numeric range checks. Mirrors the toNumber pattern used by
// FormValidators.requiredNumber/optionalNumber (kept inline here because
// those helpers don't expose the .min/.max chain we need).
const toNumber = z.union([z.number(), z.string()])
  .transform(v => (v === '' || v === undefined ? 0 : Number(v)))

// Toneladas: opcional, no negativa y con tope. Sin tope, un 1e30 no cabía en el decimal de
// .NET (JsonException) y abortaba la aprobación entera de una solicitud de modificación;
// los negativos se guardaban sin aviso.
const MAX_TONNAGE = 10_000_000
const optionalTonnage = toNumber
  .pipe(z.number({ message: 'Ingrese un número válido' }).min(0, 'No puede ser negativo').max(MAX_TONNAGE, 'Valor fuera de rango'))
  .optional()

export const step5ProductionSchema = z.object({
  period: toNumber.pipe(z.number().min(1, 'Periodo es requerido')),
  year: toNumber.pipe(z.number().int().min(2000, 'Año inválido').max(currentYear + 1, 'Año inválido')),
  dailyEstimatedProduction: optionalTonnage,
  presentationDate: z.string().optional(),
  fileNumber: z.string().min(1, 'N° Expediente es requerido'),
  totalMetallic: optionalTonnage,
  totalNonMetallic: optionalTonnage,
  expirationDate: z.string().optional(),
}).superRefine((data, ctx) => {
  validateEmissionDate(data.presentationDate, 'presentationDate', ctx)
})

export type Step5ProductionFormValues = z.infer<typeof step5ProductionSchema>

const defaultValues: Step5ProductionFormValues = {
  period: 1, // EneJun
  year: currentYear,
  dailyEstimatedProduction: 0,
  presentationDate: '',
  fileNumber: '',
  totalMetallic: 0,
  totalNonMetallic: 0,
  expirationDate: '',
}

export const useStep5ProductionForm = (props?: { defaultValues?: Step5ProductionFormValues; disabled?: boolean }) => {
  return useZodForm<Step5ProductionFormValues>({
    validationSchema: step5ProductionSchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
}
